export enum Routes {
  // signup
  SEND_OTP = '/api/v1/otp/send-verification-code',
  VERIFY_OTP = '/api/v1/otp/verify-code',
  VERIFY_CAPTCHA = '/api/v1/users/verify-recaptcha',
  START_EMAIL_SIGNUP = '/api/v1/users/start-email-signup',
  COMPLETE_SIGNUP = '/api/v1/users/complete-signup',

  // tokens
  ISSUE_ACCOUNTS_HUB_TOKEN = '/api/v1/tokens/accounts-hub',
  ISSUE_DEVELOPER_TOKEN = '/api/v1/tokens/developer',

  // other
  UPGRADE_TO_ENTERPRISE = '/api/v1/upgrade/enterprise',
  UPGRADE_TO_ENTERPRISE_AWS = '/api/v1/upgrade/enterprise-aws',

  // user
  UPDATE_USER_DETAILS = '/api/v1/user/update-details',
  LOGOUT = '/api/logout'
}
